import React from 'react';
import { Box, Typography, Alert, Button } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ProfileCard from '../components/users/ProfileCard';
import { mockUsers } from '../data/mockData';

const Profile: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  const user = mockUsers.find(u => u.id === id);

  if (!user) {
    return (
      <Box>
        <Alert severity="error">Usuario no encontrado</Alert>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/usuarios')}
          sx={{ mt: 2 }}
        >
          Volver a Usuarios
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/usuarios')}
        sx={{ mb: 2 }}
      >
        Volver a Usuarios
      </Button>
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
        Perfil de Usuario
      </Typography>
      <Box sx={{ maxWidth: 600 }}>
        <ProfileCard user={user} />
      </Box>
    </Box>
  );
};

export default Profile;
